import { useEffect, useRef, type ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { StableNavigateContext } from './context'

export function StableNavigateContextProvider({ children }: { children: ReactNode }) {
  const navigate = useNavigate()
  const navigateRef = useRef(navigate)

  useEffect(() => {
    navigateRef.current = navigate
  }, [navigate])

  return (
    <StableNavigateContext value={navigateRef}>
      {children}
    </StableNavigateContext>
  )
}
